


export const searchBy = {
    filterType: "Sort By",
    inputName: "search_by",
    options: [
      {
        name: "Descending ",
        code: "desc",
      },
      {
        name: "Ascending",
        code: "asc",
      },
    ],
  };
  
  export  const filters = [
    {
      filterType: "Gender",
      inputName: "gender",
      options: [
        {
          name: "Male",
          code: "Male",
        },
        {
          name: "Female",
          code: "Female",
        },
        {
          name: "Others",
          code: "Others",
        },
      ],
    },
    {
      filterType: "Country",
      inputName: "country",
      options: [],
    },
    {
      filterType: "City",
      inputName: "city",
      options: [],
    },
   
  ]
  
  export const canlenderFilter={
    filterType:"Created",
    inputName:"createdAt",  
    maxDate :new Date()
  }
  
  
  
  
   
  


export default {  
    filters:filters,
    SearchBy:searchBy  ,
    // WeekRange:WeekRange,
    // MonthRange:MonthRange,
    canlenderFilter:canlenderFilter,    
  }